<template>
	<div>
		<div class="con1">
			<div class="con1_t fl_r fl_j_b fl_a_c">
				<div class="con1_t_l">{{datas.name}}</div>
				<div class="con1_t_r">{{datas.price}}/月</div>
			</div>
			<div class="con1_c fl_r fl_j_s fl_a_c">
				<div class="con1_c_i fl_r fl_j_s fl_a_c">
					<div class="con1_c_i_l">招聘人数：</div>
					<div class="con1_c_i_r">{{datas.zprs}}人</div>
				</div>
				<div class="con1_c_i fl_r fl_j_s fl_a_c">
					<div class="con1_c_i_l">工作区域：</div>
					<div class="con1_c_i_r">柯桥区/马鞍山...</div>
				</div>
				<div class="con1_c_i fl_r fl_j_s fl_a_c">
					<div class="con1_c_i_l">工龄要求：</div>
					<div class="con1_c_i_r">{{datas.glyq}}</div>
				</div>
				<div class="con1_c_i fl_r fl_j_s fl_a_c">
					<div class="con1_c_i_l">学历要求：</div>
					<div class="con1_c_i_r">{{datas.xl}}</div>
				</div>
			</div>
			<div class="con1_b fl_r fl_j_s fl_a_c">
				<div class="con1_b_i"> 五险 </div>
				<div class="con1_b_i"> 包吃住 </div>
				<div class="con1_b_i"> 节假日礼品 </div>
				<div class="con1_b_i"> 免费体检 </div>
			</div>
			<div class="con1_bs fl_r fl_j_b fl_a_c">
				<div class="con1_bs_i">绍兴塞特印染有限公司</div>
				<div class="con1_bs_i">2024-4-28</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "listitem",
		props: {
			datas: {
				type: Object,
				default: function () {
					return {}
				},
			},
			type: {
				type: Number,
				default: 0,
			},
			index: {
				type: Number,
				default: 0,
			}
		},
		data () {
			return {};
		},
		methods: {
			godetail () {
				this.$router.push('/gqxxinfo')
			},
		}
	}
</script>
<style lang="less" scoped>
	.con1s {
		margin-right: 0px !important;
	}

	.con1 {
		width: 400px;
		background-color: #fff;
		margin-bottom: 15px;
		border-radius: 6px;
		border: 1px solid #eee;

		.con1_t {
			width: 90%;
			padding-top: 10px;

			.con1_t_l {
				padding-left: 10px;
				color: #333;
				font-size: 14px;
				font-weight: bold;
			}

			.con1_t_r {
				padding-right: 10px;
				color: #EA4012;
				font-size: 14px;
				font-weight: bold;
			}
		}

		.con1_c {
			width: 90%;
			padding-left: 10px;
			padding-right: 10px;
			flex-wrap: wrap;

			.con1_c_i {
				width: 180px;
				padding-top: 10px;

				.con1_c_i_l {
					color: #666;
					font-size: 12px;
				}

				.con1_c_i_r {
					color: #333;
					font-size: 12px;
				}
			}
		}

		.con1_b {
			width: 94%;
			margin: 0 auto;
			margin-top: 10px;

			.con1_b_i {
				padding: 4px 6px;
				color: #333;
				border-radius: 4px;
				font-size: 12px;
				background-color: #eee;
				margin-right: 6px;
			}
		}

		.con1_bs {
			width: 94%;
			margin: 0 auto;
			margin-top: 10px;
			padding-bottom: 10px;

			.con1_bs_i {
				color: #333;
				font-size: 12px;
			}
		}
	}
</style>